import { makeConfigProxy } from "./accessors";
import type {
  AppConfig,
  AssessConfig,
  DataHistoryAppConfig,
  IntegrationsAppConfig,
  SyncHealthConfig,
} from "./types";

export const appConfig: AppConfig = makeConfigProxy<AppConfig>("AppConfig");

export const integrationsAppConfig: IntegrationsAppConfig =
  makeConfigProxy<IntegrationsAppConfig>("IntegrationsAppConfig");

export const dataHistoryAppConfig: DataHistoryAppConfig =
  makeConfigProxy<DataHistoryAppConfig>("DataHistoryAppConfig");

export const syncHealthConfig: SyncHealthConfig =
  makeConfigProxy<SyncHealthConfig>("SyncHealthConfig");

export const assessConfig: AssessConfig =
  makeConfigProxy<AssessConfig>("AssessConfig");

export { MissingConfigGlobalError, ReadonlyConfigError } from "./accessors";
export type {
  AppConfig,
  AssessConfig,
  DataHistoryAppConfig,
  Environment,
  IntegrationsAppConfig,
  SyncHealthConfig,
} from "./types";
